/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachLinkOffIcon32Regular = forwardRef('AttachLinkOffIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l26 26a1 1 0 0 0 1.414-1.414l-4.579-4.58A8 8 0 0 0 23 8h-4a1 1 0 1 0 0 2.001h4a6 6 0 0 1 .401 11.987L18.414 17H22a1 1 0 1 0 0-2h-5.586l-5-5H13a1 1 0 1 0 0-2H9.414L3.707 2.293Z" }),
        React.createElement("path", { d: "M4.748 9.223A8 8 0 0 0 9 24h4a1 1 0 1 0 0-2H9a6 6 0 0 1-2.789-11.314L4.748 9.223Z" }),
        React.createElement("path", { d: "M10.525 15H9a1 1 0 1 0 0 2h3.525l-2-2Z" })));
});
